import {MapState} from 'src/common/map/MapState';
import {Graphics} from 'pixi.js';
import GameConfig from 'src/game/GameConfig';
import GameModel from 'src/game/GameModel';

export class GridRenderer {
    private grid: Graphics = new Graphics();

    public showForMap(map: MapState): void {
        this.grid.clear();
        this.grid.lineStyle(1, 0xffffff);
        this.grid.alpha = 0.33;
        for (let y = 0; y < map.height; y++) {
            this.grid
                .moveTo(0, y * GameConfig.tileSize)
                .lineTo(map.width * GameConfig.tileSize, y * GameConfig.tileSize);
        }
        for (let x = 0; x < map.width; x++) {
            this.grid
                .moveTo(x * GameConfig.tileSize, 0)
                .lineTo(x * GameConfig.tileSize, map.height * GameConfig.tileSize);
        }
        GameModel.cursorContainer.addChild(this.grid);
    }

    public hide(): void {
        GameModel.cursorContainer.removeChild(this.grid);
    }
}

export const gridRenderer = new GridRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/map/GridRenderer.ts